import { logger } from '@adornis/base/logging.js';
import { context } from '@adornis/baseql/server/context.js';
import { matchingMailTemplateRegisterunctions, type MatchingMailTemplateDefinitions } from './templates/index.js';

// MatchingMailRegistry
// NOTE: the mail templates have to be registered after the configuration is set, so the mail templates have to be registered and stored here after the package initialization
export let mmr = {} as MatchingMailTemplateDefinitions;

export function registerMatchingMails() {
  for (const [key, registerMailTemplate] of Object.entries(matchingMailTemplateRegisterunctions)) {
    try {
      const mailTemplateDefinition = registerMailTemplate();
      mmr[key] = mailTemplateDefinition;
    } catch (e) {
      if (context.serverContext) logger.error({ err: e, key }, 'could not register mail template');
      else console.log({ err: e, key }, 'could not register mail template');
    }
  }
}
